import { RichtextValue, Localized } from "@robe/core";
import { SlateValue, useSlateValue } from "@robe/client";
import { BoxProps } from "@xcorejs/ui";
import { sanitizeRichtextContent } from "./utils";
import { renderElement } from "./renderElement";
import { renderLeaf } from "./renderLeaf";
import { ElementProps } from "./types";
import { useEffect, useState } from "react";

interface RichtextProps extends ElementProps, BoxProps {
  value: RichtextValue | Localized<RichtextValue> | undefined;
}

const Richtext = ({ value, ...props }: RichtextProps) => {
  const [hydrated, setIsHydrated] = useState<boolean>(false);

  // prevent hydration errors by ensuring the component is mounted before rendering
  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const slateValue = useSlateValue(value);
  const slateValueSanitized = sanitizeRichtextContent(slateValue);
  if (!slateValueSanitized?.value || !hydrated) {
    return null;
  }

  return <SlateValue {...slateValueSanitized} renderElement={renderElement} renderLeaf={renderLeaf} elementProps={props} {...props} />;
};

export default Richtext;
